module.exports = __webpack_public_path__ + "static/media/ic_close_history.bc16fb16.svg";